import React from 'react';
import { Pause, Save, Trash2, X } from 'lucide-react';
import { Button } from '@common/Button';

export const StopRecordingModal = ({ onClose, onPause, onSave, onDelete }) => {
  return (
    <div className="fixed inset-0 bg-black/80 backdrop-blur-sm flex items-center justify-center z-[60] p-4">
      <div className="bg-[#2A2B2E] rounded-lg w-full max-w-md">
        <div className="flex justify-between items-center p-4 border-b border-gray-700">
          <h2 className="text-lg font-bold text-white">Stop Recording</h2>
          <button 
            onClick={onClose}
            className="p-2 hover:bg-gray-700 rounded-lg"
          >
            <X className="w-6 h-6 text-white" />
          </button>
        </div>

        <div className="p-6 space-y-4">
          <p className="text-gray-300">What would you like to do with the recorded track?</p>

          <div className="grid grid-cols-1 gap-3">
            <Button
              onClick={onPause}
              className="flex items-center justify-center gap-2 bg-yellow-600 hover:bg-yellow-700 text-white p-4"
            >
              <Pause className="w-5 h-5" />
              <div className="text-left">
                <span className="font-medium block">Pause Recording</span>
                <span className="text-sm text-white/80">Continue recording later</span>
              </div>
            </Button>

            <Button
              onClick={onSave}
              className="flex items-center justify-center gap-2 bg-green-600 hover:bg-green-700 text-white p-4"
            >
              <Save className="w-5 h-5" />
              <div className="text-left">
                <span className="font-medium block">Save as Route</span>
                <span className="text-sm text-white/80">Save track points as a new route</span>
              </div>
            </Button>

            <Button
              onClick={onDelete}
              className="flex items-center justify-center gap-2 bg-red-600 hover:bg-red-700 text-white p-4"
            >
              <Trash2 className="w-5 h-5" />
              <div className="text-left">
                <span className="font-medium block">Delete Track</span>
                <span className="text-sm text-white/80">Discard recorded track points</span>
              </div>
            </Button>
          </div>
        </div>
      </div>
    </div>
  );
};